<template>
    <Card :title="$t('labels.create_delivery')">
        <div class="card-body">
            <div class="row">
                <FormGroup class="col-lg-3 col-md-6" :class="{'mb-0': isCustom}" :label="$t('labels.method')">
                    <DeliveryMethodSelect
                        :model-value="method"
                        @update:model-value="(newMethod) => {method = newMethod; city = null; warehouse = null}"
                    />
                </FormGroup>
                <FormGroup class="col-lg-9 col-md-6" :class="{'mb-0': isCustom}" :label="$t('labels.address')">
                    <Input v-model="address" />
                </FormGroup>
            </div>
            <template v-if="!isCustom">
                <div class="row">
                    <FormGroup class="col-lg-2 col-md-6" :label="$t('labels.city')">
                        <AppAutoComplete
                            :url="`/projects/${$route.params.projectUuid}/crm/delivery/providers/${method}/cities`"
                            :model-value="city?.uuid"
                            :selected-value="formatDeliveryCityName(city)"
                            @update:model-value="(newCity) => {city = newCity; warehouse = null}"
                            :queryParams="{
                                orders: [
                                    { column: 'name', dir: 'asc'}
                                ]
                            }"
                            can-be-empty
                        >
                            <template #optionItem="{option}">
                                {{ formatDeliveryCityName(option) }}
                            </template>
                        </AppAutoComplete>
                    </FormGroup>
                    <FormGroup class="col-lg-5 col-md-6" :label="$t('labels.department')">
                        <AppAutoComplete
                            :url="`/projects/${$route.params.projectUuid}/crm/delivery/providers/${method}/cities/${city?.uuid}/warehouses`"
                            :model-value="warehouse?.uuid"
                            :selected-value="warehouse?.name"
                            :disabled="!city"
                            @update:model-value="warehouse = $event"
                            :queryParams="{
                                orders: [
                                    { column: 'name', dir: 'asc'}
                                ]
                            }"
                            can-be-empty
                        />
                    </FormGroup>
                    <FormGroup class="col-lg-3 col-md-6" :label="$t('labels.recipient_name')">
                        <Input v-model="recipientName" />
                    </FormGroup>
                    <FormGroup class="col-lg-2 col-md-6" :label="$t('labels.recipient_phone')">
                        <Input v-model="recipientPhone" />
                    </FormGroup>
                </div>
                <div class="row">
                    <FormGroup class="col-lg-4 col-md-6 mb-0" :label="$t('labels.company_number')">
                        <Input v-model="companyNumber" />
                    </FormGroup>
                    <FormGroup class="col-lg-4 col-md-6 mb-0" :label="$t('labels.delivery_zebra')">
                        <UniformFileUpload v-model="stickerFile" type="delivery-sticker" :disabled="!companyNumber" />
                    </FormGroup>
                    <FormGroup class="col-lg-4 col-md-6 mb-0" :label="$t('labels.delivery_invoice')">
                        <UniformFileUpload v-model="waybillFile" type="delivery-waybill" :disabled="!companyNumber" />
                    </FormGroup>
                </div>
            </template>
        </div>
        <div class="card-footer d-flex justify-content-end">
            <Button color="indigo" @click="createDelivery">
                {{ $t('buttons.create') }}
            </Button>
        </div>
    </Card>
</template>
<script>
import Card from "../../../../../components/new/CardComponent.vue";
import FormGroup from "../../../../../components/new/form/group/FormGroup.vue";
import Input from "../../../../../components/new/form/Input.vue";
import Button from "../../../../../components/new/button/AppButton.vue";
import UniformFileUpload from "../../../../../components/new/file/UniformFileUpload.vue";
import AppAutoComplete from "../../../../../components/new/form/autocomplete/AppAutoComplete.vue";
import DeliveryMethodSelect from "../../../../components/select/DeliveryMethodSelect.vue";

import { CUSTOM_DELIVERY_METHOD, DeliveryIntegrationsEnum, showDeliveryIntegration } from "../../../../enums/DeliveryIntegrationsEnum";
import { httpClient } from "../../../../../services/HttpClient";
import { formatDeliveryCityName } from "../../../../../utils";

export default {
    name: 'DeliveriesCreatePage',
    components: {
        Card, FormGroup, Input, Button, UniformFileUpload, AppAutoComplete, DeliveryMethodSelect
    },
    emits: ['update'],
    props: {
        order: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            method: DeliveryIntegrationsEnum.NOVAPOST,
            address: '',
            recipientName: this.order?.client?.name || '',
            recipientPhone: this.order?.client?.phone || '',
            companyNumber: '',
            waybillFile: null,
            stickerFile: null,
            city: null,
            warehouse: null
        }
    },
    computed: {
        isCustom() {
            const isCustom = this.method === CUSTOM_DELIVERY_METHOD;

            return isCustom;
        },
        methodLabel() {
            const label = this.isCustom
                ? this.$t('labels.custom_delivery')
                : showDeliveryIntegration(this.method);

            return label;
        }
    },
    methods: {
        formatDeliveryCityName,
        createDelivery() {
            const request = {
                method_label: this.methodLabel,
                address: this.address || null
            };

            if (!this.isCustom) {
                request.method = this.method;
                request.recipient_name = this.recipientName || null;
                request.recipient_phone = this.recipientPhone || null;
                request.company_number = this.companyNumber?.replace(/\s/g, '') || null;
                request.city_uuid = this.city?.uuid ?? null;
                request.warehouse_uuid = this.warehouse?.uuid ?? null;

                if (this.waybillFile) {
                    request.waybill_file_uuid = this.waybillFile.uuid;
                }

                if (this.stickerFile) {
                    request.sticker_file_uuid = this.stickerFile.uuid;
                }
            }

            httpClient.post(`/projects/${this.$route.params.projectUuid}/crm/orders/${this.$route.params.orderUuid}/deliveries`, request).then(() => {
                this.$emit('update');
                this.$router.push({
                    name: 'OrderDeliveriesPage'
                });
            });
        }
    }
}
</script>
